import React, { useEffect, useState } from 'react';
import adminOperations from '../../services/adminOperationsService';
import { Notice } from './ConsoleUI';

const money = (value) => Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: 8 });

export default function CustomerWithdrawalAllowance({ userId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let current = true;
    adminOperations.getCustomerWithdrawalAllowance(userId)
      .then((result) => { if (current) setData(result); })
      .catch((err) => { if (current) setError(err.message); });
    return () => { current = false; };
  }, [userId]);

  return <section className="space-y-3">
    <h3 className="font-semibold">Withdrawal allowance</h3>
    {error && <Notice error>{error}</Notice>}
    {!data && !error && <p className="text-sm text-slate-400">Calculating current allowance…</p>}
    {data && <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      <div className="rounded-xl border border-slate-800 bg-slate-950 p-3"><p className="text-xs text-slate-500">Tier</p><p className="mt-1 text-lg font-semibold">{data.tier ? `Level ${data.tier.level}` : 'Not configured'}</p>{data.uses_default_tier && <p className="text-xs text-slate-500">Default assignment</p>}</div>
      <div className="rounded-xl border border-slate-800 bg-slate-950 p-3"><p className="text-xs text-slate-500">Monthly limit</p><p className="mt-1 font-mono text-sm">{money(data.monthly_limit_usdt)} USDT</p></div>
      <div className="rounded-xl border border-slate-800 bg-slate-950 p-3"><p className="text-xs text-slate-500">Used this month</p><p className="mt-1 font-mono text-sm">{money(data.used_this_month_usdt)} USDT</p></div>
      <div className="rounded-xl border border-slate-800 bg-slate-950 p-3"><p className="text-xs text-slate-500">Remaining</p><p className={`mt-1 font-mono text-sm ${Number(data.remaining_this_month_usdt) > 0 ? 'text-emerald-300' : 'text-rose-300'}`}>{money(data.remaining_this_month_usdt)} USDT</p><p className="text-xs text-slate-500">Resets {new Date(data.resets_at).toLocaleString()}</p></div>
    </div>}
  </section>;
}
